import * as Sentry from "@sentry/react";

const BLOG_URL =
	import.meta.env.VITE_BLOG_URL ?? "https://the-buzz.coffitivity.com";

// Shape of each entry in the blog's build-time feed at /api/latest-articles.json.
// Mirrors the endpoint in apps/blog/src/pages/api/latest-articles.json.ts.
export interface BuzzArticle {
	title: string;
	description: string;
	series: string;
	seriesLabel: string;
	publishedDate: string;
	url: string;
	image: string | null;
	imageAlt: string | null;
}

interface LatestArticlesResponse {
	articles: BuzzArticle[];
}

// Public, read-only URL of The Buzz, used for the "Visit The Buzz" link.
export const buzzHomeUrl = BLOG_URL;

// Fetch the latest published articles from The Buzz. This is public JSON served
// as a static Cloudflare asset (CORS: *), so no auth or credentials are needed.
export async function fetchLatestBuzzArticles(): Promise<BuzzArticle[]> {
	try {
		const response = await fetch(`${BLOG_URL}/api/latest-articles.json`, {
			headers: { Accept: "application/json" },
		});

		if (!response.ok) {
			throw new Error(`Failed to fetch Buzz articles: ${response.status}`);
		}

		const json: LatestArticlesResponse = await response.json();
		return json.articles ?? [];
	} catch (error) {
		Sentry.captureException(error);
		throw error;
	}
}
